<pax-section [sectionTitle]="productAgnosticCustomRouteData.pageTitle">
</pax-section>
